import React from 'react';
import { User } from 'lucide-react';
import { homePageStyles } from './HomePage.styles';
import UserProfile from '../UserProfile';

const HeaderButtons = ({ 
  loading, 
  user, 
  profileOpen, 
  setProfileOpen, 
  profileRef, 
  navigate 
}) => {
  return (
    <div style={homePageStyles.headerButtons} className="header-buttons">
      {loading ? (
        <div style={homePageStyles.loadingSpinner}>
          <div style={homePageStyles.loadingSpinnerInner}></div>
        </div>
      ) : user ? (
        <div ref={profileRef} style={{ position: 'relative' }}>
          <div
            style={homePageStyles.profileButton}
            onClick={() => setProfileOpen((open) => !open)}
            title={user.displayName || user.email}
          >
            {user.displayName ? user.displayName.charAt(0).toUpperCase() : user.email.charAt(0).toUpperCase()}
          </div>
          {profileOpen && <UserProfile />}
        </div>
      ) : (
        <button 
          onClick={() => {
            navigate('/auth');
          }}
          className="btn btn-primary"
          data-testid="login-button"
          style={homePageStyles.loginButton}
        >
          <User size={18} />
          Login
        </button>
      )}
    </div>
  );
};

export default HeaderButtons; 